import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectWorkingSession, selectWorkingSessionCaptionsEnabled } from '@/store/slices/project/selectors';
import Container from '@ui/container/container';
import Switch from '@ui/switch/switch';
import Text from '@ui/text/text/text';
import { saveWorkingProjectSessionByField } from '@/store/slices/project';

const EditSessionCaptions = () => {
  const dispatch = useAppDispatch();

  const session = useAppSelector(selectWorkingSession);
  const captionsEnabled = useAppSelector(selectWorkingSessionCaptionsEnabled);

  const handleToggle = () => {
    if (!session) return;
    const isOn = !!session.streaming_options?.auto_transcripts;

    dispatch(
      saveWorkingProjectSessionByField({
        uuid: session.uuid,
        streaming_options: {
          ...session.streaming_options,
          auto_transcripts: !isOn,
        },
      })
    );
  };

  return (
    <Container>
      <Container className="flex ai-center jc-space-between">
        <Text className="L3 padding-b-8">CAPTIONS</Text>
      </Container>
      <Container className="padding-t-8">
        <Switch on={captionsEnabled} onClick={handleToggle} value={captionsEnabled} />
      </Container>
    </Container>
  );
};

export default EditSessionCaptions;
